export const householdOwnsPortfolio = (
  financialProductId?: string | null,
): boolean => Boolean(financialProductId);

/**
 * Account household wins; goal household is the GOAL-entry fallback.
 *
 * Callers distinguish pending vs resolved ownership with:
 * - `undefined` — not yet resolved (e.g. goal fetch still in flight)
 * - `null` / `''` — resolved: no model
 * - string id — resolved: owns a model
 *
 * This helper treats both `undefined` and `null` as falsy (does not own).
 * Loading gates that must wait for resolution should check `=== undefined`
 * separately before calling this.
 */
export const resolveCreateSubAccountHouseholdOwnsModel = ({
  accountHouseholdProductId,
  goalHouseholdProductId,
}: {
  accountHouseholdProductId?: string | null;
  goalHouseholdProductId?: string | null;
}): boolean =>
  householdOwnsPortfolio(accountHouseholdProductId) ||
  householdOwnsPortfolio(goalHouseholdProductId);
